import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/35_card_back_pagoda/35_card_back_pagoda"
 * Contains 1 texture(s)
 */
export class CardsBacks35CardBackPagodaAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/35_card_back_pagoda/35_card_back_pagoda';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '35_pagoda.png'
    ] as const;
}
